// ═══════════════════════════════════════════════════════════════
// Usuarios EasyRural — sincronizado con el correo de Adrià del 24-jul-2026
// (CUPS + nombres reales de los propietarios).
//
// Niveles:
//   1. admin       → ve TODOS los alojamientos (incluidos borradores)
//   2. multi-owner → varios alojamientos (grupo familiar / gestor)
//   3. single      → UN solo alojamiento (el propietario particular)
//
// `locationIDs` es SIEMPRE un array. Para admin va como ["*"].
// Los IDs deben coincidir con `EasyRural_Clientes` en Node-RED
// (backend cloud). Ver `infra/clients_reference.md` en el repo para
// el mapeo Alojamiento1..5 → CUPS + NIF autorizado + plan.
// ═══════════════════════════════════════════════════════════════

// Mapeo alojamientos ↔ propietarios (backend Node-RED 27-jul-2026):
//   Alojamiento1 → Refugi de la Pleta   · Eduard Gonzalez Romero · 45833744B · 2 CUPS · Baix Pallars · PLAN BÁSICO
//   Alojamiento2 → Casa Adrià           · Adrià González Romero  · 45833743X · ES0031406121398003ZZ0F · PLAN BÁSICO
//   Alojamiento3 → Masia La Boira       · Maria Isabel Romero Leon · 38823377K · ES0031406147952003MP0F · PLAN BÁSICO
//   Alojamiento4 → Masia Can Mulo       · Juan Roca Casquet      · 77899160T · ES0031406116508001VL0F · PLAN BÁSICO
//   Alojamiento5 → Masia Can Orta       · Juan Dalmau Blanch     · 77894736S · 2 CUPS pendientes · piloto sensórica · BORRADOR → PLAN COMPLETO

export const DEMO_USERS = [
  // ─── ADMIN ─────────────────────────────────────────────
  { email: "admin@easyrural.demo",      password: "Admin2026!",   role: "admin",   locationIDs: ["*"], nombre: "Administrador EasyRural" },

  // ─── ADRIÀ (CEO) — multi-owner de sus propiedades familiares ─
  //   Casa Adrià (Alojamiento2) + Refugi de la Pleta de su hermano Eduard (Alojamiento1)
  { email: "adria@easyrural.net",       password: "AdriaCEO2026!", role: "cliente", locationIDs: ["Alojamiento2", "Alojamiento1"], nombre: "Adrià González Romero", nif: "45833743X" },

  // ─── DUEÑOS SINGLE-OWNER (uno por alojamiento del correo) ─
  { email: "eduard.gonzalez@easyrural.demo", password: "Pleta2026!",   role: "cliente", locationIDs: ["Alojamiento1"], nombre: "Eduard Gonzalez Romero",   nif: "45833744B" },
  { email: "isabel.romero@easyrural.demo",   password: "LaBoira2026!", role: "cliente", locationIDs: ["Alojamiento3"], nombre: "Maria Isabel Romero Leon", nif: "38823377K" },
  { email: "juan.roca@easyrural.demo",       password: "CanMulo2026!", role: "cliente", locationIDs: ["Alojamiento4"], nombre: "Juan Roca Casquet",        nif: "77899160T" },
  { email: "juan.dalmau@easyrural.demo",     password: "CanOrta2026!", role: "cliente", locationIDs: ["Alojamiento5"], nombre: "Juan Dalmau Blanch",       nif: "77894736S" },
];

// ─── ALOJAMIENTOS DEMO EXTRAS (fallback) ─────────────────────────
// Solo se muestran si el backend NO los tiene aún. En cuanto el backend
// los tenga registrados de verdad (POST /api/clients), tienen prioridad.
// Los IDs de aquí deben coincidir con los locationIDs que usan los DEMO_USERS.
export const DEMO_EXTRA_CLIENTS = [];

// Une los clientes del backend con los demo extras (sin duplicar por locationID).
export function mergeWithDemoClients(backendClients) {
  const list = Array.isArray(backendClients) ? backendClients : [];
  if (!DEMO_EXTRA_CLIENTS.length) return list;
  const knownIds = new Set(list.map(c => c.locationID));
  const extras = DEMO_EXTRA_CLIENTS.filter(d => !knownIds.has(d.locationID));
  return [...list, ...extras];
}

export function findUser(email, password) {
  const e = String(email || "").trim().toLowerCase();
  return DEMO_USERS.find(u => u.email.toLowerCase() === e && u.password === password) || null;
}

// Devuelve true si el user puede ver el alojamiento con id `locationID`.
export function canAccess(user, locationID) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (Array.isArray(user.locationIDs) && user.locationIDs.includes("*")) return true;
  if (Array.isArray(user.locationIDs)) return user.locationIDs.includes(locationID);
  // Compat con formato viejo (locationID string único)
  if (user.locationID) return user.locationID === locationID;
  return false;
}

// Filtra un array de clientes/markers dejando solo los accesibles.
export function filterAccessible(user, clients) {
  if (!user || !Array.isArray(clients)) return [];
  if (user.role === "admin") return clients;
  if (Array.isArray(user.locationIDs) && user.locationIDs.includes("*")) return clients;
  const ids = Array.isArray(user.locationIDs)
    ? user.locationIDs
    : (user.locationID ? [user.locationID] : []);
  return clients.filter(c => ids.includes(c.locationID));
}
